var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "music_note",
    transform: "translate(-12773.917 -3061.616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_5475",
    "data-name": "\\u9577\\u65B9\\u5F62 5475",
    width: 24,
    height: 24,
    transform: "translate(12773.917 3061.616)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_5483",
    "data-name": "\\u9577\\u65B9\\u5F62 5483",
    width: 20,
    height: 20,
    transform: "translate(12775.917 3063.616)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_5146",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5794",
    "data-name": "\\u30D1\\u30B9 5794",
    d: "M6.3,13.908V2L17.862,0V13.973c0,1.1-1.577-2.153-1.577-2.153V3.5L7.88,5V16.06C7.88,17.163,6.3,13.908,6.3,13.908Z",
    transform: "translate(12776.54 3063.616)",
    fill: "#5fc7bc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_238",
    "data-name": "\\u6955\\u5186\\u5F62 238",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(12777.417 3076.116)",
    fill: "#5fc7bc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_239",
    "data-name": "\\u6955\\u5186\\u5F62 239",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(12787.402 3074.616)",
    fill: "#5fc7bc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music_note.f0ed387e3903059215a4bdd0d1b821d2.svg";
export { ForwardRef as ReactComponent };